import Vue from 'vue';
import QuoteFilters from '@/components/Quotes/QuoteFilters';
Vue.use(QuoteFilters);
